module.exports = __webpack_public_path__ + "img/ic_favorite_off.56322032.svg";